import { render } from "./VHeader.vue?vue&type=template&id=00177395"
const script = {}

import "./VHeader.vue?vue&type=style&index=0&id=00177395&lang=scss"

import exportComponent from "E:\\Project\\Vue\\keep-calm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__